// Automatic focus before the first interaction must not look like keyboard navigation.
// Preserve a modality already set by an earlier interaction or a script reload.
document.documentElement.dataset.lazyOafInputModality ||= 'pointer';

// Keep dialog focus rings tied to the interaction that opened or navigated them.
// Programmatic focus on a drawer's close button can otherwise inherit a stale
// :focus-visible state after a pointer click in some browsers.
document.addEventListener('pointerdown', () => {
  document.documentElement.dataset.lazyOafInputModality = 'pointer';
}, true);

document.addEventListener('keydown', (event) => {
  if (event.altKey || event.ctrlKey || event.metaKey) return;
  document.documentElement.dataset.lazyOafInputModality = 'keyboard';
}, true);
